import UpdateNeeded from './UpdateNeeded'
export class MICRInfo {
    RequestID: number;
    BankKey?: string;
    BankAccount?: string;
    UpdateNeededID?: number;
    UpdateNeeded?: UpdateNeeded;
}

export default MICRInfo;